import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Divider, Form } from "semantic-ui-react";
import useAuth from "../../../login/AuthContext";
import {
  CreateSubnetwork,
  SubnetworkCreationRequest,
} from "../../../../services/NetworkApi";
import { ErrorResponse } from "../../../../services/Common";
import { SubNetworkCreationPieces, UnitCreationPieces } from "./FormPieces";
import { useNetworkContext } from "../../../../contexts/NetworkContext/context";

interface CreateSubnetworkModalProps {
  show: boolean;
  onClose: () => void;
  l1Id: number;
}

export const CreateSubnetworkModal: React.FunctionComponent<CreateSubnetworkModalProps> = ({
  show,
  onClose,
  l1Id,
}) => {
  const [error, setError] = useState({ error: false, msg: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { getAuthToken } = useAuth();
  const { loadNetworkInfoForNetworks } = useNetworkContext();
  const defaultInfoData = {
    subnetworkName: undefined,
    unitSize: undefined,
    unitTypeName: undefined,
    matchingStartDate: null,
    matchingEndDate: null,
    activationStartDate: null,
    activationEndDate: null,
  };
  const [info, setInfo] = useState<SubnetworkCreationRequest>(defaultInfoData);

  const defaultErrorsData = {
    subnetworkNameError: false,
    unitTypeNameError: false,
    unitSizeError: false,
    matchingDatesError: false,
  };
  const [errors, setErrors] = useState(defaultErrorsData);

  const resetData = () => {
    setInfo(defaultInfoData);
    setErrors(defaultErrorsData);
    setIsSubmitting(false);
    setError({ error: false, msg: "" });
  };

  const validateFields = () => {
    const validationErrors = { ...errors };

    let errored = false;

    validationErrors.subnetworkNameError = info.subnetworkName == undefined;
    errored = errored || info.subnetworkName == undefined;

    validationErrors.unitTypeNameError = info.unitTypeName == undefined;
    errored = errored || info.unitTypeName == undefined;

    validationErrors.unitSizeError =
      info.unitSize == undefined || info.unitSize < 1;
    errored = errored || info.unitSize == undefined || info.unitSize < 1;
    
    const isEveryDateIsSet = (info.matchingStartDate !== null && info.matchingEndDate !== null && info.activationStartDate !== null && info.activationEndDate !== null);
    const isEveryDateIsNull = (info.matchingStartDate === null && info.matchingEndDate === null && info.activationStartDate === null && info.activationEndDate === null);
    if(isEveryDateIsSet === false && isEveryDateIsNull === false) {
      validationErrors.matchingDatesError = true;
    }
    errored = errored || validationErrors.matchingDatesError;

    setErrors(validationErrors);
    return !errored;
  };

  const setValue = (value: string | boolean | number | null, field: string) => {
    setInfo({ ...info, [field]: value });
  };
  return (
    <Modal show={show} onHide={onClose} onExit={resetData}>
      <Modal.Header closeButton>
        <Modal.Title>Create Matching Round</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          error={error.error}
          onSubmit={async (event) => {
            event.preventDefault();

            if (isSubmitting) {
              return;
            }

            if (validateFields()) {
              setIsSubmitting(true);
              setError({ error: false, msg: "" });

              try {
                const createSubnetwork = await CreateSubnetwork(
                  l1Id,
                  info,
                  await getAuthToken()
                );

                if (
                  !createSubnetwork ||
                  createSubnetwork instanceof ErrorResponse
                ) {
                  setError({ msg: "something went wrong", error: true });
                  return;
                }

                await loadNetworkInfoForNetworks([l1Id]);
                onClose();
              } catch (error) {
                setError({ msg: "something went wrong", error: true });
              } finally {
                setIsSubmitting(false);
              }
            }
          }}
        >
          <SubNetworkCreationPieces
            subnetworkNameError={errors.subnetworkNameError}
            matchingDatesError={errors.matchingDatesError}
            setValue={setValue}
          />

          <Divider />

          <UnitCreationPieces
            unitTypeNameError={errors.unitTypeNameError}
            unitSizeError={errors.unitSizeError}
            setValue={setValue}
          />

          <Button
            style={{ marginTop: "5px" }}
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Adding..." : "Add"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
